import { useEffect } from "react";

/**
 * While a screen opened from an emailed link is showing, the token may still be in the address bar,
 * so the browser must not pass it on as a referrer to anything the page loads or links to. Sets
 * `<meta name="referrer" content="no-referrer">` for the screen's lifetime and puts back whatever
 * was there.
 */
export function useHideReferrer(): void {
  useEffect(() => {
    const existing = document.head.querySelector<HTMLMetaElement>(
      'meta[name="referrer"]'
    );
    const meta = existing ?? document.createElement("meta");
    const previous = existing?.content;
    meta.name = "referrer";
    meta.content = "no-referrer";
    if (!existing) document.head.append(meta);

    return () => {
      if (existing && previous !== undefined) existing.content = previous;
      else meta.remove();
    };
  }, []);
}
